var map = {
	"./_default": "ot4p",
	"./_default.js": "ot4p",
	"./foodfactory": "Yfjl",
	"./foodfactory.js": "Yfjl",
	"./freshbox": "LF1p",
	"./freshbox.js": "LF1p",
	"./mobilonline": "k9WD",
	"./mobilonline.js": "k9WD",
	"./murat": "5Lff",
	"./murat.js": "5Lff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "Xs4W";
module.exports = webpackContext;